import axios from 'axios';
import config from '../constants/config';
import urlJoin from 'url-join';
import store from '../store';
import { getFileUploadUrl } from '../actions/files';

export const getJsonData = (url) => {
  return new Promise((resolve, reject) => {

    axios
      .get(url)
      .then((response) => {
        return resolve(response.data);
      })
      .catch((error) => {
        return reject(error);
      });
  });
};

// TODO: it seems that manual call of axios that results in 401 is not intercepted and logout is not triggered

export const newFileUpload = (file) => {
  return new Promise((resolve, reject) => {
    const { type } = file || {};
    store
      .dispatch(getFileUploadUrl(type))
      .then((data) => {
        if (data?.type === 'files/GET_UPLOAD_URL_SUCCESS') {
          const { url, fileId } = data?.payload?.data || {};
          axios({
            url,
            method: 'put',
            data: file,
            headers: {
              'x-amz-acl': 'private',
              'Content-Type': file.type,
              'Content-Length': file.size
            }
          })
            .then(() => {
              resolve({ fileId });
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          reject(data);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createGetCountryIsoByIpAction = (fallbackCountry) => {
  // intl-tel-input v28+ expects a function returning a Promise<string>.
  return () =>
    getJsonData(config.geoIpUrl).then(
      (data = '') => data.split(';')[1] || fallbackCountry,
      () => fallbackCountry
    );
};

export const forwardGeocoding = (query, params) => {
  return new Promise((resolve, reject) => {
    axios
      .get(urlJoin(config.mapboxEndpoint, 'mapbox.places', `${query}.json`), { params })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const reverseGeocoding = ([lat, lng], params) => {
  return new Promise((resolve, reject) => {
    axios
      .get(urlJoin(config.mapboxEndpoint, 'mapbox.places', `${lng},${lat}.json`), {
        params
      })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
